export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Russia-62670ca9616515fa7246862224a3404b.mp3";